import React, { useState } from 'react';
import { ApiService } from 'services/ApiService';
import { useNavigate } from "react-router-dom";

// User must already be registered.
const ArtistSignUpComponent: React.FC = () => {
    const userId = localStorage.getItem("userId");
    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [instagramUsername, setInstagramUsername] = useState<string>("");
    const navigate = useNavigate();
    
    const handleArtistSignUp = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const signupRequest = {
            id: userId ?? "",
            userName: username,
            password: password,
            instagramUsername: instagramUsername
        };

        try {
            const response = await ApiService.signUpArtist(signupRequest);
            if (response.success) {
                alert("Artist sign up successful!");
                navigate(`/artist/${response.data?.artist.userId}`);
            } else {
                alert("Artist sign up failed. Please try again.");
            }
        } catch (error) {
            console.error("Artist sign up error:", error);
            alert("Artist sign up failed. Please try again.");
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
                <h2 className="text-2xl font-bold mb-6 text-center">Artist Sign Up</h2>
                <form onSubmit={handleArtistSignUp}>
                    <div className="mb-4">
                        <label htmlFor="username" className="block text-gray-700 font-bold mb-2">Username:</label>
                        <input
                            type="text"
                            id="username"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="instagramUsername" className="block text-gray-700 font-bold mb-2">Instagram Username:</label>
                        <input
                            type="text"
                            id="instagramUsername"
                            placeholder="Username"
                            value={instagramUsername}
                            onChange={(e) => setInstagramUsername(e.target.value)}
                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="password" className="block text-gray-700 font-bold mb-2">Password:</label>
                        <input
                            type="password"
                            id="password"
                            placeholder="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                    <button
                        type="submit"
                        className="w-full bg-blue-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-blue-700 transition duration-300"
                    >
                        Sign Up
                    </button>
                </form>
            </div>
        </div>
    );
}

export default ArtistSignUpComponent;